import React, { useMemo } from 'react';
import { ModalDropdownItemTrigger } from '@atlassian/entry-point-modal-trigger/ModalDropdownItemTrigger';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { defineMessages, useIntl } from '@atlassian/jira-intl';
import { optInModalEntryPoint } from './modal/optInModalEntryPoint.tsx';

export const messages = defineMessages({
	menuItemLabel: {
		id: 'admin-pages-field-schemes.ui.legacy-cmp-project.action-menu-item.non-final',
		defaultMessage: 'Use a different scheme (new)',
		description:
			'Label for new menu item in actions dropdown on legacy CMP Project Settings Fields page',
	},
});

type Props = {
	projectId: string;
};
export const ActionMenuItem = (props: Props) => {
	const cloudId = useCloudId();
	const { formatMessage } = useIntl();
	const { projectId } = props;

	const entrypointParams = useMemo(() => {
		return {
			cloudId,
			projectId,
		};
	}, [cloudId, projectId]);

	// For some reason Modal does not seem to work when using it with `component={BasicLink}`
	// Due to this, we've kept it as a button
	return (
		<ModalDropdownItemTrigger entryPoint={optInModalEntryPoint} entryPointParams={entrypointParams}>
			{formatMessage(messages.menuItemLabel)}
		</ModalDropdownItemTrigger>
	);
};
